import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-32 pb-24 min-h-[80vh]">
      <div className="max-w-md mx-auto px-6">
        <div className="label-eyebrow mb-4">Account</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tighter">
          Sign in
        </h1>

        <form onSubmit={submit} className="mt-12 space-y-8">
          <label className="block">
            <span className="label-eyebrow block mb-2">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-[#e5e5e5] py-3 text-base focus:outline-none focus:border-[#111] transition-colors"
              data-testid="login-email"
            />
          </label>
          <label className="block">
            <span className="label-eyebrow block mb-2">Password</span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-[#e5e5e5] py-3 text-base focus:outline-none focus:border-[#111] transition-colors"
              data-testid="login-password"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#111] text-white px-8 py-4 text-sm font-medium hover:bg-[#333] transition-colors disabled:opacity-60"
            data-testid="login-submit"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="mt-8 text-sm text-[#666]">
          New here?{" "}
          <Link to="/register" className="text-[#111] font-medium hover:opacity-70">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
